// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K4oaxtCIfbsdBRcRRtAj {
    background-color: var(--qa-chatfieldBackgroundColor);
    border-radius: 10px;
    padding: 7.5px 10px;
    cursor: pointer;
    color: var(--qa-chatfieldTextColor);
    border: 1px solid var(--qa-chatfieldBorderColor);
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    justify-content: flex-start;
    gap: 10px;
    margin-top: auto;
}

.K4oaxtCIfbsdBRcRRtAj input {
    padding: 0;
    font-size: var(--qa-chatFieldFontSize);
    font-weight: 500;
    text-align: left;
    border: none;
    flex-grow: 1;
    background-color: transparent;
    outline: none;
}

.K4oaxtCIfbsdBRcRRtAj input::placeholder {
    color: var(--qa-chatfieldPlaceholderColor);
}

.K4oaxtCIfbsdBRcRRtAj input:focus {
    outline: none;
    caret-color: var(--qa-chatfieldTextColor);
    color: var(--qa-chatfieldTextColor);
}

/* .chatButtonContainer svg {
    color: #cecece;
    font-size: 25px;
} */

._xfFbvKy0L3VBBM0Q4N8 {
    color: var(--qa-chatfieldIconColor);
    font-size: 25px;
    opacity: 0.3;
}


.wfGbD2NM8FawrK0ZGFBv {
    color: var(--qa-chatfieldIconColor);
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./app/components/ChatField/ChatField.module.css"],"names":[],"mappings":"AAAA;IACI,oDAAoD;IACpD,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,mCAAmC;IACnC,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,sCAAsC;IACtC,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,mCAAmC;AACvC;;AAEA;;;GAGG;;AAEH;IACI,mCAAmC;IACnC,eAAe;IACf,YAAY;AAChB;;;AAGA;IACI,mCAAmC;IACnC,UAAU;AACd","sourcesContent":[".chatButtonContainer {\n    background-color: var(--qa-chatfieldBackgroundColor);\n    border-radius: 10px;\n    padding: 7.5px 10px;\n    cursor: pointer;\n    color: var(--qa-chatfieldTextColor);\n    border: 1px solid var(--qa-chatfieldBorderColor);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    text-align: center;\n    justify-content: flex-start;\n    gap: 10px;\n    margin-top: auto;\n}\n\n.chatButtonContainer input {\n    padding: 0;\n    font-size: var(--qa-chatFieldFontSize);\n    font-weight: 500;\n    text-align: left;\n    border: none;\n    flex-grow: 1;\n    background-color: transparent;\n    outline: none;\n}\n\n.chatButtonContainer input::placeholder {\n    color: var(--qa-chatfieldPlaceholderColor);\n}\n\n.chatButtonContainer input:focus {\n    outline: none;\n    caret-color: var(--qa-chatfieldTextColor);\n    color: var(--qa-chatfieldTextColor);\n}\n\n/* .chatButtonContainer svg {\n    color: #cecece;\n    font-size: 25px;\n} */\n\n.sendIcon {\n    color: var(--qa-chatfieldIconColor);\n    font-size: 25px;\n    opacity: 0.3;\n}\n\n\n.chatInput {\n    color: var(--qa-chatfieldIconColor);\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export var chatButtonContainer = `K4oaxtCIfbsdBRcRRtAj`;
export var sendIcon = `_xfFbvKy0L3VBBM0Q4N8`;
export var chatInput = `wfGbD2NM8FawrK0ZGFBv`;
export default ___CSS_LOADER_EXPORT___;
